<template>
  <div v-if="permission.admin_delete" @click="deleteAdmin()">
    <div class="bin-icon">
      <font-awesome-icon
        class="bin"
        icon="trash-alt"
        :style="{ color: '#ff4a3d' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params);
  },
  computed: {
    permission() {
      return this.$store.getters.getPermission;
    },
  },
  methods: {
    async deleteAdmin() {
      this.$root.$emit("delete-modal", this.params.data.user_id);
    },
  },
};
</script>

<style scoped>
.bin {
  margin-bottom: 13px;
}

.bin-icon {
  text-align: center;
  width: 23px;
  height: 23px;
  border-radius: 7px;
  border: solid 1px #ff4a3d;
  cursor: pointer;
}
</style>
